export default __webpack_public_path__ + "static/media/reloj.af94dd4f.png";